/**
 * external dependencies
 */
import axios, { AxiosError } from "axios";

/**
 * internal dependencies
 */
import { showToast } from "../../components/toasts";

/**
 * Handles route errors
 * 
 * @param {any} error the error
 * @param {string} toastMsg the default toast message if an error message is not returned
 * 
 * @returns void
 */
export const handleRouteError = (error: any, toastMsg: string) => {
  const err = error as AxiosError;
  const submitSpinner = document.querySelector('.aafp_submit-spinner') as HTMLElement;
  submitSpinner?.classList.remove('aafp_button-loading');
  if (axios.isAxiosError(err)) {    
    if ( typeof err.response!.data === 'string' ) {
      const parsedError = JSON.parse(err.response!.data);
      //console.log('error response', parsedError)
      const errorMsg = parsedError || toastMsg;
      showToast('aafp_toast-alert', errorMsg);
    } else {
      //const errorMsg = err.response!.data.body.message || toastMsg;
      showToast('aafp_toast-alert', toastMsg);
    }
  } else {
    showToast('aafp_toast-alert', toastMsg);
  }
}